import React from 'react';
import { MessageType } from '../../../../../services/actor-messages';
import WorkspaceItemContext from '../../../../contexts/workspace/workspace-item-context';
import { useAppSelector } from '../../../../hooks/store-hooks';
import { useFlightWorker } from '../../../../hooks/use-flight-worker';
import { useSafeEffect } from '../../../../hooks/use-safe-effect';
import { store } from '../../../../state/store';

export function FlightIndividual() {
    const context = React.useContext(WorkspaceItemContext);
    const showPinned = useAppSelector((x) => x.workspace.flights.settings.showPinned);
    const flightTags = useAppSelector((x) => x.workspace.individual.tags);
    const flightHistory = useAppSelector((x) => x.workspace.individual.history);
    const flightVectors = useAppSelector((x) => x.workspace.individual.vector);
    const flightRings = useAppSelector((x) => x.workspace.individual.rangeRings);
    const flightPlannedRoutes = useAppSelector((x) => x.workspace.individual.flightPath);
    const flightFlownRoutes = useAppSelector((x) => x.workspace.individual.routeFlown);
    const worker = useFlightWorker();

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setShowPinnedIcons, data: showPinned });
    }, [worker, showPinned]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightsIndividualTags, data: flightTags });
    }, [worker, flightTags]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightIndividualHistory, data: flightHistory });
    }, [worker, flightHistory]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightIndividualVectors, data: flightVectors });
    }, [worker, flightVectors]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightsIndividualRings, data: flightRings });
    }, [worker, flightRings]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightsWithIndividualPlannedRoutes, data: flightPlannedRoutes });
        const state = store.getState();
        const workspace = state.workspace.items[context.id];
        const visibleFlights = context.flightLayerFacade.routes.getFlights();
        // NOTE: I wonder if we should be adding/removing routes when they are actually added/removed
        //       Right now we're just reacting to state change and it's tricky to figure out exactly what got added/removed
        //

        // Got over all visible routes
        for (const id of visibleFlights) {
            // If it's supposed te be visible because it's an individual route, skip
            if (flightPlannedRoutes.includes(id)) {
                continue;
            }

            // If it's supposed to be visible because it's selected flight, skip
            if (workspace.flights.selected.some((x) => x.details.id === id)) {
                continue;
            }

            // Here we need to remove only 1 route for this flight keep the other one if necessary
            context.flightLayerFacade.routes.removeFlight(id, {
                keep: {
                    flightPlan: flightPlannedRoutes.includes(id),
                    flown: state.workspace.individual.routeFlown.includes(id)
                }
            });
        }
    }, [worker, context, flightPlannedRoutes]);

    useSafeEffect(() => {
        worker.actor.sendAsync({ type: MessageType.setFlightsWithIndividualRouteFlown, data: flightFlownRoutes });
        const state = store.getState();
        const workspace = state.workspace.items[context.id];
        const visibleFlights = context.flightLayerFacade.routes.getFlights();
        for (const id of visibleFlights) {
            if (flightFlownRoutes.includes(id)) {
                continue;
            }

            if (workspace.flights.selected.some((x) => x.details.id === id)) {
                continue;
            }

            context.flightLayerFacade.routes.removeFlight(id, {
                keep: {
                    flightPlan: state.workspace.individual.flightPath.includes(id),
                    flown: flightFlownRoutes.includes(id)
                }
            });
        }
    }, [worker, flightFlownRoutes]);

    return <></>;
}
